<template>
    <div class="DashboardEditSection" :id="id">
        <Row>
            <Column class="titleColumn" :lg="3">
                <h3>{{ title }}</h3>
            </Column>

            <Column :lg="9">
                <Card>
                    <slot></slot>
                </Card>
            </Column>
        </Row>
    </div>
</template>

<script>
import Card from '@/components/Card';

export default {
    name: 'DashboardEditSection',

    components: { Card },

    props: {
        id: { type: String, required: false },
        title: { type: String, required: true },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardEditSection {
    & + & {
        margin-top: 30px;
    }

    .Card {
        width: 100%;
    }

    .titleColumn {
        margin-top: 10px;
    }

    @include breakpoint(md) {
        .titleColumn {
            margin: 10px;
        }
    }

    // Subtitles within section
    ::v-deep h2 {
        margin-bottom: $grid-gutter-width;
        font-weight: $font-weight-regular;
    }
}
</style>
